export interface DeploymentEnvironment {
  key: string;
  label: string;
  color: string; 
}

const ENVIRONMENTS: ReadonlyArray<{ hosts: readonly string[] } & DeploymentEnvironment> = [
  { hosts: ['localhost', '127.0.0.1'], key: 'local', label: 'DEV', color: '#6c757d'  },
  { hosts: ['admin-test.emts-groupe.fr'], key: 'test', label: 'TEST', color: '#6f1d1b' },
];

const DEFAULT_ENVIRONMENT: DeploymentEnvironment = { key: 'prod', label: '', color: '#171d3f' };

export function getDeploymentEnvironment(hostname = window.location.hostname): DeploymentEnvironment {
  const match = ENVIRONMENTS.find((environment) => environment.hosts.includes(hostname));
  return match ? { key: match.key, label: match.label, color: match.color } : DEFAULT_ENVIRONMENT;
}
